import { CREATE_ADHOC_ROOM } from "./types";

export const createAdHocRoom = () => ({
  type: CREATE_ADHOC_ROOM,
});
